<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 30/11/2021
  -->

<template>
	<el-checkbox v-bind="$attrs"><slot></slot></el-checkbox>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";

export default {
	name: "QwCheckbox",
	extends: BaseComponent,
	inheritAttrs: false,

}
</script>

<style lang="scss">

</style>
